// import i18n from "@/plugins/i18n";
import {cloneDeep} from 'lodash';
export default {
  setSnackbar({ commit }, snackbar) {
    snackbar.showing = snackbar.showing || true;

    if (snackbar.type) {
      snackbar.color = snackbar.type;
    } else {
      snackbar.color = snackbar.color || "success";
      snackbar.icon = "mdi-check";
    }

    snackbar.timeout = snackbar.timeout || 4000;

    commit("SET_SNACKBAR", snackbar);
  },

  logout(context) {
    context.commit("SET_PAGE_LOADING", true);

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        context.commit("LOGOUT");
        context.commit("SET_PAGE_LOADING", false);
        resolve();
      }, 500);
    });
  },

  init(context, { user, token, i18n, vuetify }) {
    return new Promise((resolve, reject) => {
      axios.get("languages").then((res) => {
        context.commit("SET_LANGUAGES", res.data);
        context.commit("SET_ACCESS_TOKEN", token);

        var userLanguage = res.data.find((lang) => lang.id == user.language_id);
        user.language = userLanguage;

        context.commit("SET_CURRENT_USER", user);
        const unitSystem = user.unitSystem;
        axios
          .get("labels?language=" + userLanguage.shortcode+"&unitSystem="+unitSystem)
          .then((labels) => {
            i18n.setLocaleMessage(userLanguage.shortcode, labels.data);
            i18n.locale = userLanguage.shortcode;

            if (vuetify.framework) {
              vuetify.framework.lang.current = userLanguage.shortcode;
            } else {
              vuetify.lang.current = userLanguage.shortcode;
            }

            context.commit("SET_LABELS", labels.data);
            resolve("SUCCESS");
          });
      });
    });
  },

  initBeforeAuthentication(context, { i18n, vuetify }) {
    return new Promise((resolve, reject) => {
      axios.get("languages").then((res) => {
        context.commit("SET_LANGUAGES", res.data);

        var userLanguage = res.data.find((lang) => lang.shortcode === 'en');
        
        axios
          .get("labels?language=" + userLanguage.shortcode)
          .then((labels) => {
            i18n.setLocaleMessage(userLanguage.shortcode, labels.data);
            i18n.locale = userLanguage.shortcode;

            if (vuetify.framework) {
              vuetify.framework.lang.current = userLanguage.shortcode;
            } else {
              vuetify.lang.current = userLanguage.shortcode;
            }

            context.commit("SET_LABELS", labels.data);
            resolve("SUCCESS");
          });
      });
    });
  },

  changeLanguage(context, { user }) {
    return new Promise((resolve, reject) => {
      if (context.state.currentUser.id !== user.id) return resolve("SKIP"); // ONLY CHANGE LANG IF WE MODIFYING THE CURRENT USER
      var userLanguage = context.state.languages.find(
        (lang) => lang.id == user.language_id
      );

      
      const oldUserLanguageId = context.state.currentUser.language_id;
      const oldUnitSystem = cloneDeep(context.state.currentUser.unitSystem);
      user.language = userLanguage;

      context.commit("SET_CURRENT_USER", user);
      
      if (oldUserLanguageId === user.language_id && oldUnitSystem === user.unitSystem) return resolve("SKIP");
      const unitSystem = user.unitSystem;
              
      axios.get("labels?language=" + userLanguage.shortcode+"&unitSystem="+unitSystem).then((labels) => {
        i18n.setLocaleMessage(userLanguage.shortcode, labels.data);
        i18n.locale = userLanguage.shortcode;

        if (vuetify.framework) {
          vuetify.framework.lang.current = userLanguage.shortcode;
        } else {
          vuetify.lang.current = userLanguage.shortcode;
        }

        context.commit("SET_LABELS", labels.data);
        resolve("SUCCESS");
      });
    });
  },

  fetchLabels(context, { lang }) {
    const unitSystem = context.state.currentUser.unitSystem;
    return axios.get("labels?language=" + lang+"&unitSystem="+unitSystem).then((res) => {
      context.commit("SET_LABELS", res.data);
      return res.data;
    });
  },
};
